const LOAD_DETAIL_DOCUMENT_TYPE           = 'LOAD_DETAIL_DOCUMENT_TYPE'
const LOAD_DETAIL_DOCUMENT_TYPE_SUCCESS   = 'LOAD_DETAIL_DOCUMENT_TYPE_SUCCESS'
const LOAD_DETAIL_DOCUMENT_TYPE_FAILED    = 'LOAD_DETAIL_DOCUMENT_TYPE_FAILED'
const UNMOUNT_DETAIL_DOCUMENT_TYPE        = 'UNMOUNT_DETAIL_DOCUMENT_TYPE'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const DocumentTypeDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_DOCUMENT_TYPE:
      return{
        ...state,
        data: null,
        loading: true,
      }
    case LOAD_DETAIL_DOCUMENT_TYPE_SUCCESS:
      return{ 
        ...state, 
        data: action.payload.data,
        loading: false,
        message: 'SUCCESS'
      }
    case LOAD_DETAIL_DOCUMENT_TYPE_FAILED:
      return{ 
        ...state, 
        data: null,
        loading: true,
        message: 'FAILED'
      }
      case UNMOUNT_DETAIL_DOCUMENT_TYPE:
        return{ 
          ...state, 
          data: null,
          loading: true,
        }
    default:
      return state
  }


}

export default DocumentTypeDetailReducer;